<template>
  <div class="inner-main">
    <div class="item"
      v-for="mem in memberList"
      :key="mem.id">
      <!-- <div class="left">
                <van-image width="4rem" height="4rem" :src="mem.photo" />
            </div> -->
      <div class="center"
        @click="detail(mem)">
        <div class="head-name">{{mem.name}}</div>
        <div class="title">{{mem.position}}<span v-if="mem.offline">(已离职)</span> </div>
        <div class="title">
          <span v-text="userIndustry(mem.userIndustry)"> </span>
        </div>
      </div>
      <div class="right">
        <div class="div-btn"
          v-if="!mem.isRecognized"
          @click="addRelation(mem.id)">
          {{$t('recognize')}}
        </div>
        <div class="div-btn known"
          @click="editRelationship(mem)"
          v-else>
          <!-- 我已认识他 -->
          {{$t('recognized')}}
        </div>
        <div class="relation">关联<span style="color: #D04A02;">{{mem.relationCount}}</span>条PwC关系</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    memberList: {
      type: Array,
    },
    memberType: {
      type: String,
    },
    orgId: {
      type: String,
      default: '',
    },
  },
  components: {},

  computed: {},

  mounted () { },

  methods: {
    addRelation (id) {
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          id: id,
          orgId: this.orgId,
          type: this.memberType,
        },
      });
    },
    editRelationship (mem) {
      var relId = mem.id;
      if (this.memberType == "org") {
        relId = mem.investedCompanyRelationshipId;
      }
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          relationshipId: relId,
          type: this.memberType,
          isEdit: true,
          orgId: this.orgId,
        },
      });
    },
    detail (mem) {
      if (this.memberType == "company") {
        if (mem.isRecognized) {
          this.$router.push({
            path: "/contractorDetailCompany",
            query: {
              id: mem.id,
              editId: mem.investedCompanyRelationshipId,
              isEdit: true,
            },
          });
        } else {
          this.$router.push({
            path: "/contractorDetailCompany",
            query: {
              id: mem.id,
            },
          });
        }
      } else {
        if (mem.isRecognized) {
          this.$router.push({
            path: "/contractorDetail",
            query: {
              id: mem.id,
              editId: mem.investedCompanyRelationshipId,
              isEdit: true,
            },
          });
        } else {
          this.$router.push({
            path: "/contractorDetail",
            query: {
              id: mem.id,
            },
          });
        }
      }
    },
    userIndustry (item) {
      //处理专注行业
      let userIndustry = '';
      if (!_.isEmpty(item) && item.length > 0) {
        let industries = _.split(item, ',');
        if (industries.length < 4) {
          userIndustry = _.join(industries, '，');
        }
        else {
          let firstThr = _.slice(industries, 0, 3);
          let otherInd = _.slice(industries, 3, industries.length);
          userIndustry = _.join(firstThr, '，');
        }
      }
      return userIndustry;
    }
  },
};
</script>
<style lang='less' scoped>
.inner-main {
  padding: 1.125rem 1.125rem 1.125rem 0.5rem;
}
.item {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(221, 221, 221);

  .left {
    width: 4rem;
  }
  .center {
    width: 60%;
    padding-left: 20px;
    font-size: 16px;
    padding-right: 5px;
    .head-name {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: bolder;
      width: 70%;
      padding-bottom: 0.5rem;
    }
    .title {
      //padding: 0.25rem 0;
      color: #7d7d7d;
      font-size: 0.75rem;
      word-break: break-all;
    }
  }
  .right {
    // text-align: right;
    // flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //padding-right: 10px;
    .div-btn {
      border: 1px solid #c52a1a;
      text-align: center;
      color: #c52a1a;
      font-size: 10px;
      line-height: 20px;
    }
    .known {
      color: #7d7d7d;
      border-color: #7d7d7d;
    }
    .relation {
      //margin-top: 14px;
      padding: 0.25rem 0;
      color: #7d7d7d;
      font-size: 0.75rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/MemberList.vue